// src/features/medicine-inventory/hooks/useInventory.js
import { useContext, useMemo } from 'react';
import { InventoryContext } from '../context/InventoryContext';

export const useInventory = () => {
  const context = useContext(InventoryContext);
  
  if (!context) {
    throw new Error('useInventory must be used within InventoryProvider');
  }
  
  // Calculate stats using useMemo for performance
  const stats = useMemo(() => ({
    totalMedicines: context.medicines?.length || 0,
    totalCategories: context.categories?.length || 0,
    lowStockItems: context.medicines?.filter(m => m.currentStock <= m.reorderLevel).length || 0,
    totalValue: context.medicines?.reduce((sum, m) => sum + (m.currentStock * m.price), 0) || 0
  }), [context.medicines, context.categories]);

  return {
    ...context,
    stats
  };
};